"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runCookieConsentTool = exports.removeCookieConsent = exports.getCookieConsentForPurpose = exports.waitUntilElementExists = exports.CookiePurposes = exports.CookiePolicies = void 0;
var CookiePolicies;
(function (CookiePolicies) {
    CookiePolicies[CookiePolicies["EN"] = 77828385] = "EN";
    CookiePolicies[CookiePolicies["DE"] = 81942693] = "DE";
    CookiePolicies[CookiePolicies["FR"] = 96927727] = "FR";
    CookiePolicies[CookiePolicies["NL"] = 12638414] = "NL";
})(CookiePolicies || (exports.CookiePolicies = CookiePolicies = {}));
var CookiePurposes;
(function (CookiePurposes) {
    CookiePurposes[CookiePurposes["ESSENTIAL"] = 1] = "ESSENTIAL";
    CookiePurposes[CookiePurposes["FUNCTIONAL"] = 2] = "FUNCTIONAL";
    CookiePurposes[CookiePurposes["MARKETING"] = 3] = "MARKETING";
})(CookiePurposes || (exports.CookiePurposes = CookiePurposes = {}));
const waitUntilElementExists = (selector, callback) => {
    const el = document.querySelector(selector);
    if (el) {
        return callback();
    }
    setTimeout(() => (0, exports.waitUntilElementExists)(selector, callback), 50);
};
exports.waitUntilElementExists = waitUntilElementExists;
/**
 * Returns true if the passed `purpose` matches the already set cookie's purpose
 * @param purpose CookiePurpose -> MARKETING, ESSENTIAL or FUNCTIONAL
 */
const getCookieConsentForPurpose = (purpose) => {
    const language = document.documentElement.lang.toUpperCase();
    const cookieRegex = new RegExp(`_iub_cs-${CookiePolicies[language]}=(.*?)(?=;|$)`);
    const cookie = document.cookie.match(cookieRegex);
    if (cookie) {
        const cookieObject = JSON.parse(decodeURIComponent(cookie.pop()));
        if (cookieObject.purposes[purpose])
            return true;
    }
    return false;
};
exports.getCookieConsentForPurpose = getCookieConsentForPurpose;
const removeCookieConsent = () => {
    const language = document.documentElement.lang.toUpperCase();
    const cookieRegex = new RegExp(`_iub_cs-${CookiePolicies[language]}=(.*?)(?=;|$)`);
    const cookie = document.cookie.match(cookieRegex);
    const domain = location.hostname.match(new RegExp('.*tails-nonprod\\.com.*'))
        ? 'tails-nonprod.com'
        : location.hostname;
    if (cookie) {
        document.cookie = `${cookie}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Domain=.${domain}`;
    }
};
exports.removeCookieConsent = removeCookieConsent;
/**
 * Runs the cookie consent tool to display the cookie consent dialog box
 */
const runCookieConsentTool = (reopen = false, logoURL = 'https://tails.com/static/images/svgs/logos/logo.svg') => {
    if (window.dataLayer === undefined)
        window.dataLayer = [];
    if (window._iub === undefined)
        window._iub = [];
    if (window.optimizelyEdge === undefined)
        window.optimizelyEdge = [];
    if (window.gtag === undefined) {
        window.gtag = function () {
            // @ts-ignore
            window.dataLayer.push(arguments);
        };
    }
    // remove exist cookie if present
    if (reopen)
        (0, exports.removeCookieConsent)();
    const lang = document.documentElement.lang;
    const copy = {
        en: {
            header: 'Cookies at tails.com',
            subheader: `We use some essential cookies to keep our site secure and reliable. We'd also like to set additional
        cookies to understand how you use tails.com and personalise that experience to you (and your dog).`,
            accept: 'Accept additional cookies',
            reject: 'Reject additional cookies',
            learnMore: 'Learn more and customise',
            preferences: 'Your preferences',
            essential: 'Essential',
            essentialText: `Our website needs these cookies to work properly, so we can’t switch them off.
        They let us save your privacy settings, signup progress, and remember things like your dog's
        name.`,
            functional: 'Functional',
            functionalText: `These cookies make our site even more usable by allowing extra functions
        (e.g. live chat). They also let us monitor site usage to measure and improve content and
        quality.`,
            marketing: 'Marketing',
            marketingText: `These cookies let us display personalised adverts to you and your dog. They
        can be set up on our site by our advertising partners.`,
            read: 'Read description',
            save: 'Save'
        },
        de: {
            header: 'Cookies bei tails.com',
            subheader: `Wir verwenden notwendige Cookies, um unsere Website sicher und zuverlässig zu machen. Gerne würden wir
       zusätzliche Cookies sammeln, um zu erfahren, wie du mit tails.com interagierst und dadurch unsere Website für
        dich (und deinen Hund) noch relevanter zu machen.`,
            accept: 'Zusätzliche Cookies zulassen',
            reject: 'Zusätzliche Cookies ablehnen',
            learnMore: 'Mehr erfahren und anpassen',
            preferences: 'Deine Präferenzen',
            essential: 'Essenziell',
            essentialText: `Unsere Website benötigt diese Cookies, damit sie richtig funktioniert. Deshalb
        können wir sie nicht ausschalten. Wir speichern damit deine Datenschutzeinstellungen, deinen
        Anmeldefortschritt und merken uns Infos, wie den Namen deines Hundes.`,
            functional: 'Funktionell',
            functionalText: `Diese Cookies verbessern das Nutzererlebnis auf unserer Website durch
        zusätzliche Funktionen (z. B. Live-Chat). Außerdem können wir damit die Seitennutzung
        analysieren, um Content und Qualität zu messen und zu verbessern.`,
            marketing: 'Marketing',
            marketingText: `Mit diesen Cookies können wir personalisierte Werbung für dich und deinen Hund
        anzeigen. Diese kann von unseren Werbepartnern auf unserer Website zur Verfügung gestellt
        werden.`,
            read: 'Beschreibung lesen',
            save: 'Speichern'
        },
        nl: {
            header: 'Cookies bij tails.com',
            subheader: `Wij gebruiken noodzakelijke cookies om te zorgen dat onze site veilig en betrouwbaar blijft. We willen
       ook graag extra cookies instellen zodat we weten hoe je tails.com gebruikt en we die beleving op jou (en je hond)
        kunnen afstemmen.`,
            accept: 'Aanvullende cookies toestaan',
            reject: 'Aanvullende cookies weigeren',
            learnMore: 'Meer informatie en aanpassen',
            preferences: 'Jouw voorkeuren',
            essential: 'Strikt noodzakelijk',
            essentialText: `Onze website heeft deze cookies nodig om goed te kunnen functioneren. Daarom
        kunnen we ze niet uitzetten. We gebruiken ze om jouw privacy-instellingen op te slaan, jouw
        inloggegevens, en de naam van jouw hond te onthouden.`,
            functional: 'Functionele cookies',
            functionalText: `Deze cookies zijn noodzakelijk om onze website en andere functies te laten
        werken (bijv. live chat). We gebruiken deze cookies ook om meer informatie over onze
        bezoekers te krijgen en zo de inhoud en kwaliteit van onze website te verbeteren.`,
            marketing: 'Marketing cookies',
            marketingText: `Met deze cookies krijgen jij en je hond gepersonaliseerde advertenties te
        zien. Ze kunnen door onze reclamepartners op onze site worden geplaatst.`,
            read: 'Beschrijving lezen',
            save: 'Opslaan'
        },
        fr: {
            header: 'Cookies tails.com',
            subheader: `Nous utilisons des cookies essentiels, nécessaires à la sécurité et à la fiabilité du site. Nous
       aimerions utiliser des cookies supplémentaires pour comprendre votre utilisation de tails.com et personnaliser
        cette expérience pour vous (et votre chien).`,
            accept: 'Accepter les cookies non-essentiels',
            reject: 'Rejeter les cookies non-essentiels',
            learnMore: 'En savoir plus et paramétrer',
            preferences: 'Vos préférences',
            essential: 'Obligatoires',
            essentialText: `Notre site utilise ces cookies pour fonctionner correctement. Nous ne pouvons
        pas les désactiver. Ils nous permettent de sauvegarder vos paramètres de confidentialité et
        votre avancée dans l'inscription, ainsi que des informations comme le nom de votre chien.`,
            functional: 'Fonctionnels',
            functionalText: `Ces cookies rendent notre site plus ergonomique en activant des fonctions
        supplémentaires (p. ex.chat en direct). Ils nous permettent aussi d'observer l'utilisation
        du site pour mesurer et améliorer la qualité et le contenu.`,
            marketing: 'Marketing',
            marketingText: `Ces cookies nous permettent de proposer des publicités pertinentes pour vous
        et votre chien. Ils peuvent être utilisés par nos partenaires publicitaires.`,
            read: 'Lire la description',
            save: 'Sauvegarder'
        }
    };
    const modifyPrefText = () => {
        document.querySelector('.purposes-header-title').textContent = copy[lang].preferences;
        document.querySelector('.purpose-item-1 label').textContent = copy[lang].essential;
        document.querySelector('.purpose-item-1 .purposes-item-body').textContent =
            copy[lang].essentialText;
        document.querySelector('.purpose-item-2 label').textContent = copy[lang].functional;
        document.querySelector('.purpose-item-2 .purposes-item-body').textContent =
            copy[lang].functionalText;
        document.querySelector('.purpose-item-3 label').textContent = copy[lang].marketing;
        document.querySelector('.purpose-item-3 .purposes-item-body').textContent =
            copy[lang].marketingText;
        document.querySelectorAll('.purposes-item-title-btn')
            .forEach((el) => {
            el.textContent = copy[lang].read;
            el.attributes[1].value = copy[lang].read;
            el.attributes[2].value = copy[lang].read;
        });
        document.querySelector('#iubFooterBtn').textContent = copy[lang].save;
    };
    const setCookie = (key, value) => {
        document.cookie = `${key}=${value}; Path=/; Domain=.${location.hostname}`;
    };
    const updateConsent = (marketingConsent, functionalConsent) => {
        window.gtag('consent', 'update', {
            ad_storage: marketingConsent ? 'granted' : 'denied',
            ad_user_data: marketingConsent ? 'granted' : 'denied',
            ad_personalization: marketingConsent ? 'granted' : 'denied',
            analytics_storage: functionalConsent ? 'granted' : 'denied'
        });
    };
    window._iub.csConfiguration = {
        consentOnContinuedBrowsing: false,
        whitelabel: true,
        lang: lang,
        siteId: 2194129,
        purposes: '1, 2, 3',
        perPurposeConsent: true,
        enableCMP: false,
        cookiePolicyId: CookiePolicies[lang.toUpperCase()] || 77828385,
        banner: {
            applyStyles: false,
            acceptButtonDisplay: true,
            customizeButtonDisplay: true,
            rejectButtonDisplay: true,
            closeButtonDisplay: false,
            position: 'float-center',
            backgroundOverlay: true,
            textColor: 'black',
            backgroundColor: 'white',
            logo: logoURL
        },
        callback: {
            onBannerShown: () => document.querySelector('.iubenda-cs-customize-btn')
                .addEventListener('click', () => ((0, exports.waitUntilElementExists)('#purposes-container', () => modifyPrefText()))),
            onPreferenceExpressed: (preferences) => {
                // consent given to functional cookies
                if (preferences.purposes[CookiePurposes.FUNCTIONAL]) {
                    // @ts-ignore
                    window.optimizelyEdge.push({
                        type: 'sendEvents'
                    });
                    // @ts-ignore
                    window.dataLayer.push({
                        event: 'iubenda_consent_given_purpose_2'
                    });
                }
                // consent given to marketing cookies
                if (preferences.purposes[CookiePurposes.MARKETING]) {
                    const urlParams = new URLSearchParams(window.location.search.slice(1));
                    const partners = [
                        'awc',
                        'CLICKID',
                        'sovReqToken',
                        'subid1',
                        'OutbrainClickId',
                        'tk',
                        'tapjoyId',
                        'reqid',
                        'affid'
                    ];
                    partners.forEach((key) => {
                        if (urlParams.has(key))
                            setCookie(key, urlParams.get(key));
                    });
                    // @ts-ignore
                    window.dataLayer.push({
                        event: 'iubenda_consent_given_purpose_3'
                    });
                }
                updateConsent(preferences.purposes[CookiePurposes.MARKETING], preferences.purposes[CookiePurposes.FUNCTIONAL]);
            }
        }
    };
    const header = copy[lang].header;
    const subheader = copy[lang].subheader;
    const acceptText = copy[lang].accept;
    const rejectText = copy[lang].reject;
    const learnMoreText = copy[lang].learnMore;
    window._iub.csConfiguration.banner.html = `
    <div
      id="iubenda-cs-banner"
      class="iubenda-cs-default-floating iubenda-cs-center iubenda-cs-overlay iubenda-cs-slidein 
        iubenda-cs-branded iubenda-cs-visible"
      role="alertdialog"
      aria-labelledby="iubenda-cs-title"
      aria-describedby="iubenda-cs-paragraph"
    >
      <div class="iubenda-cs-container">
        <div class="iubenda-cs-content" style="">
          <div class="iubenda-cs-rationale">
            <div class="iubenda-cs-brand">
              <img src=${logoURL} alt="logo" />
            </div>
            <div class="iubenda-banner-content iubenda-custom-content" role="document" tabindex="0">
              <div id="iubenda-cs-title">${header}</div>
              <div id="iubenda-cs-paragraph">${subheader}</div>
            </div>
            <div class="iubenda-cs-opt-group" style="color:white!important;">
              <div class="iubenda-cs-opt-group-custom">
                <button
                  class="iubenda-cs-customize-btn"
                  tabindex="0"
                  role="button"
                  aria-pressed="false"
                >
                  ${learnMoreText}
                </button>
              </div>
              <div class="iubenda-cs-opt-group-consent">
                <button
                  class="tails-cta primary iubenda-cs-reject-btn"
                  tabindex="0"
                  role="button"
                  aria-pressed="false"
                >
                  ${rejectText}
                </button>
              </div>
              <div class="iubenda-cs-opt-group-consent">
                <button
                  class="tails-cta primary iubenda-cs-accept-btn"
                  tabindex="0"
                  role="button"
                  aria-pressed="false"
                >
                  ${acceptText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
    const node = document.createElement('script');
    node.src = '//cdn.iubenda.com/cs/iubenda_cs.js';
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
};
exports.runCookieConsentTool = runCookieConsentTool;
